/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Manage_DeleteInputs */

const en_story_manage_delete = /** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Story`)
};

const es_story_manage_delete = /** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Historia`)
};

const fr_story_manage_delete = /** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la Story`)
};

const de_story_manage_delete = /** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story löschen`)
};

const id_story_manage_delete = /** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Cerita`)
};

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const ja_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const zh_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const ar_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const it_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const ru_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const pt_story_manage_delete = en_story_manage_delete;

/** @type {(inputs: Story_Manage_DeleteInputs) => LocalizedString} */
const ko_story_manage_delete = en_story_manage_delete;

/**
* | output |
* | --- |
* | "Delete Story" |
*
* @param {Story_Manage_DeleteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_manage_delete = /** @type {((inputs?: Story_Manage_DeleteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Manage_DeleteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_manage_delete(inputs)
	if (locale === "es") return es_story_manage_delete(inputs)
	if (locale === "fr") return fr_story_manage_delete(inputs)
	if (locale === "de") return de_story_manage_delete(inputs)
	if (locale === "ja") return ja_story_manage_delete(inputs)
	if (locale === "zh") return zh_story_manage_delete(inputs)
	if (locale === "ar") return ar_story_manage_delete(inputs)
	if (locale === "id") return id_story_manage_delete(inputs)
	if (locale === "it") return it_story_manage_delete(inputs)
	if (locale === "ru") return ru_story_manage_delete(inputs)
	if (locale === "pt") return pt_story_manage_delete(inputs)
	return ko_story_manage_delete(inputs)
});